export default "__VITE_ASSET__50f819d8__"